import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';

@Component({
  templateUrl: 'number.component.html',
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class NumberFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  public static readonly defaultOptions: FormlyFieldConfig = {
    props: {
      ...MssFieldBaseFieldTypeComponent.focusBlurZeroDefault,
    },
  };

  public preventUnwanted(event: KeyboardEvent): void {
    if (['e', '+', '-'].includes(event.key) || (!this.props.allowDecimal && event.key === '.')) {
      event.preventDefault();
    }
  }
}
